import { Web3Provider } from "@ethersproject/providers";
import { useWeb3React } from "@web3-react/core";
import { injected } from "hooks/connectors";
import { useEagerConnect, useInactiveListener } from "hooks/Web3Hooks";
import { useEffect, useState } from "react";
import {
  ConnectedStatus,
  ConnectedWrapper,
  StyledConnectButton,
} from "./styled";
import { ReactComponent as CheckIcon } from "assets/icons/check.svg";
import { shortenAddr } from "utils/shortenAddr";
const ConnectButton = () => {
  const context = useWeb3React<Web3Provider>();
  const { connector, activate, account } = context;

  // handle logic to recognize the connector currently being activated
  const [activatingConnector, setActivatingConnector] = useState<any>();
  useEffect(() => {
    if (activatingConnector && activatingConnector === connector) {
      setActivatingConnector(undefined);
    }
  }, [activatingConnector, connector]);

  // handle logic to eagerly connect to the injected ethereum provider, if it exists and has granted access already
  const triedEager = useEagerConnect();

  // handle logic to connect in reaction to certain events on the injected ethereum provider, if it exists
  useInactiveListener(!triedEager || !!activatingConnector);

  const handleConnect = async () => {
    console.log(account);
    const connect = async () => {
      try {
        await activate(injected);
      } catch (e) {
        console.log(e);
      }
    };
    connect();
  };

  return (
    <>
      {!account ? (
        <StyledConnectButton onClick={handleConnect}>
          Connect Your Wallet
        </StyledConnectButton>
      ) : (
        <ConnectedWrapper gap={12}>
          <ConnectedStatus alignItems="center" gap={4} justifyContent="center">
            <CheckIcon /> <span>CONNECTED</span>
          </ConnectedStatus>
          <button>{shortenAddr(account)}</button>
        </ConnectedWrapper>
      )}
    </>
  );
};

export default ConnectButton;
